<fhm-search-page [gridData]="gridData"
                 [showLink]="true"
                 [showAdd]="type === 'all' || type.toUpperCase() === CustomerInstanceData.DEPLOYMENT_STATUS_CHEWZIE"
                 [type]="type + '-customer-instance-search'"
                 [showDelete]="false" (addNew)="createNew()"
                 [columns]="type === 'all' ? ['clientId', 'deploymentType', 'deploymentStatus'] : ['clientId', 'deploymentStatus']"
                 [showRefresh]="true"
                 (refresh)="load()"
                 (selectRecord)="recordSelected($event)">
</fhm-search-page>
